export enum EDataEngineType {
  legacy = 0,
  dal = 1
}
